import { formatTimestamp } from "../utils/indexedDBModule/saveAllModules.js";
import { changeIdbTime } from "@/utils/indexedDBModule/saveAllModules.js";
var timestamp;
// 时间戳
function debounceUpdateTimestamp(delay) {
  let timerId;
  return function () {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      timerId = null;
      timestamp = Date.now();
      //这里是给idbTimer一个初始值，避免没有变更也去提交了
      changeIdbTime(timestamp);
      //保留最后一次更新indexDB的数据时间
      localStorage.setItem(
        `changeModelTimestamp-${store.state.cadModules.rlProject_id}`,
        formatTimestamp(timestamp).full
      );
    }, delay);
  };
}

// 创建一个使用防抖的时间戳更新函数
const updateTimestampDebounced = debounceUpdateTimestamp(1000); // 设置延迟为 1000 毫秒
// --------------------------------------------------------------
import Dexie from "dexie";

// 过滤数据
import {
  formInitialValue,
  materialType,
  constructDataList,
  getConstruct,
  getKindType,
  convertShapeValToParams,
  steelSectionType,
} from "@/api/constant/modulesType.js";
import { isArray, map } from "xe-utils";
import { login } from "@/api/user";
import store from "@/store";

const fieldKey = {
  rlStdFlr:
    "&Guid,No_,Height,rlJoint,rlGrid,rlAxis,rlStdFlrPara,rlBeamSeg,rlColSeg,rlWallSeg,rlSlab,rlWallHole,rlpkpmSubBeam,rlRingBeamSeg,rlSlabHole,rlPartitionWallSeg,rlDoorsWindows,rlCantiSlab", // 标准层
  rlFloor: "&Guid,No_,Name,StdFlrGuid,LevelB,Height", // 自然层
  rlColSect: "&Guid,No_,Mat,Kind,ShapeVal,Structural", // 柱截面
  rlBeamSect: "&Guid,No_,Name,Mat,Kind,ShapeVal", // 梁/次梁截面
  rlWallSect: "&Guid,No_,Name,Mat,Kind,B,H", // 墙截面
  rlSlabSect: "&Guid,No_,Name,Mat,Kind,Thickness", // 板截面
  rlRingBeamSect: "&Guid,No_,Name,Mat,Kind,ShapeVal", // 圈梁截面
  rlWallHoleDef: "&Guid,No_,B,H", // 墙洞截面
  rlSlabHoleDef: "&Guid,No_,Kind,ShapeVal", // 板洞截面
  rlPartitionWallSect: "&Guid,Name,No_,Mat,Kind,B,H", // 隔墙截面
  rlDoorsWindowsDef: "&Guid,No_,B,H", // 门窗截面
  rlCantiSlabDef: "&Guid,No_,Width,Length,Thick,Kind", // 悬挑板截面
  rlLayer: "&Type,Color,Name,No_", // 图层
};

export let dbs = null;

export const openCurrentDb = async () => {
  if (dbs && !dbs.isOpen()) {
    console.log("重新打开数据库");
    dbs.open();
  }
};

export const closeCurrentDb = async () => {
  if (dbs && dbs.isOpen()) {
    console.log("关闭数据库");
    dbs.close();
  }
};

// 删除指定数据库
const deleteDatabase = async (databaseName) => {
  try {
    await Dexie.delete(databaseName);
    return true; // 返回删除成功的消息
  } catch (error) {
    return false; // 返回删除失败的消息
  }
};

// 数据库统一操作
export const getInitDatabase = async (idbName, KEYS, isDelete = true) => {
  try {
    const name = idbName;

    // 如果存在已打开的数据库连接，先关闭
    // if (dbs && dbs.isOpen()) {
    //   dbs.close();
    // }

    // 删除已存在的数据库
    isDelete && (await deleteDatabase(name));

    // 创建新的数据库实例
    dbs = new Dexie(name);
    dbs.version(1).stores(KEYS || fieldKey);

    return dbs; // 返回数据库实例
  } catch (error) {
    console.error(`创建数据库失败：`, error);
    throw error; // 抛出错误，便于调用者处理
  }
};

// 增 - 数据库基础赋值(初始化)
export const addInitDbData = async (projectId, data) => {
  try {
    // 两个对象的字段不完全相同时
    Object.keys(data).forEach((key) => {
      dbs.table(key).bulkAdd(data[key] ? data[key] : []);
    });
    return "初始化赋值成功";
  } catch (error) {
    return "数据库初始化" + error;
  }
};

// 保存-全局传接口
export const saveRlData = async () => {
  if (dbs) {
    try {
      // 保存数据
      const value = {
        rlStdFlr: await getrlStdFlrAll(), // 标准层
        rlFloor: await getrlFloor(), // 自然层
        rlColSect: await getRlColSect(), // 柱截面
        rlBeamSect: await getRlBeamSect(), // 梁/次梁截面
        rlWallSect: await getRlWallSect(), // 墙截面
        rlSlabSect: await getRlSlabSect(), // 板截面
        rlRingBeamSect: await getRlRingBeamSect(), // 圈梁截面
        rlWallHoleDef: await getRlWallHoleDef(), // 墙洞
        rlSlabHoleDef: await getRlslabholedef(), // 板洞截面
        rlPartitionWallSect: await getrlPartitionWallSect(), // 隔墙截面
        rlDoorsWindowsDef: await getrlDoorsWindowsDef(), // 门窗截面
        rlCantiSlabDef: await getRlCantiSlabDef(), // 悬挑板截面
        rlLayer: await getRlLayer(), // 图层
      };

      const result = { timestamp, value };
      return result;
    } catch (error) {
      return false;
      throw error; // 如果需要将错误传递给调用者，可以重新抛出错误
    }
  }
};

// 获取当前楼层初始化需要的所有数据
export const getRlInitFloorData = async (floorId) => {
  try {
    // 验证floorId是否为有效的IndexedDB键类型（字符串、数字）
    if (
      floorId === null ||
      floorId === undefined ||
      typeof floorId === "object"
    ) {
      console.error("无效的floorId:", floorId);
      return false;
    }

    const resData = {};
    // 获取当前楼层数据
    const stdFlrData = await dbs.rlStdFlr.where("Guid").equals(floorId).first();
    resData.stdFlrData = stdFlrData;

    // 获取所有的截面数据
    const wallSectData = await dbs.rlWallSect.toArray();
    resData.wallSectData = wallSectData;

    const beamSectData = await dbs.rlBeamSect.toArray();
    resData.beamSectData = beamSectData;

    const colSectData = await dbs.rlColSect.toArray();
    resData.colSectData = colSectData;

    const slabSectData = await dbs.rlSlabSect.toArray();
    resData.slabSectData = slabSectData;

    const ringBeamSectData = await dbs.rlRingBeamSect.toArray();
    resData.ringBeamSectData = ringBeamSectData;

    const wallHoleDefData = await dbs.rlWallHoleDef.toArray();
    resData.wallHoleDefData = wallHoleDefData;

    const slabHoleDefData = await dbs.rlSlabHoleDef.toArray();
    resData.slabHoleDefData = slabHoleDefData;

    const PartitionWallSectData = await dbs.rlPartitionWallSect.toArray();
    resData.PartitionWallSectData = PartitionWallSectData;

    const doorsWindowsDefData = await dbs.rlDoorsWindowsDef.toArray();
    resData.doorsWindowsDefData = doorsWindowsDefData;

    const cantiSlabDefData = await dbs.rlCantiSlabDef.toArray();
    resData.cantiSlabDefData = cantiSlabDefData;

    const layerData = await dbs.rlLayer.toArray();
    resData.layerData = layerData;

    return resData;
  } catch (error) {
    console.error("getRlInitFloorData错误:", error);
    return false;
  }
};

/**
 * 自然层数据接口
 */
// 增 - 批量
export const resetAllRlFloor = async (arr) => {
  // try
  // 更新时间戳
  updateTimestampDebounced();

  try {
    await dbs.rlFloor.clear();
    await dbs.rlFloor.bulkAdd(arr);
    return "新增成功";
  } catch (error) {
    return false;
  }
};
// 增 - 单个
export const addrlFloor = async (obj) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    await dbs.table("rlFloor").add(obj);
    return "新增成功";
  } catch (error) {
    return false;
  }
};
// 删 - 单个
export const delrlFloor = async (Guid) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    await dbs.rlFloor.where("Guid").equals(Guid).delete();
    return "删除成功";
  } catch (error) {
    return false;
  }
};
// 删 -根据标准层Guid 字段批量删除自然层
export const delBulkRlFloor = async (StdFlrGuid) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    const delArr = await bulkGetItemsByStd(StdFlrGuid);
    await dbs.rlFloor.bulkDelete(delArr);
    return "删除关联自然层成功";
  } catch (error) {
    return false;
  }
};
// 改 - 单个
export const updatelFloor = async (Guid, obj) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    await dbs.rlFloor.update(Guid, obj);
    return "更新成功";
  } catch (error) {
    return false;
  }
};
// 根据 标准层/StdFlrGuid 字段批量查找自然层表中的数据
export const bulkGetItemsByStd = async (StdFlrGuid) => {
  try {
    // 进行条件查询，根据 name 字段查询对应的数据
    const queryResult = await dbs.rlFloor
      .where("StdFlrGuid")
      .anyOf(StdFlrGuid)
      .toArray();
    // 将查询结果的 id 提取出来
    const ids = queryResult.map((item) => item.Guid);
    return ids;
  } catch (error) {
    return [];
  }
};

// 修改自然层层高以及底标高
export const updateOnlyFloorHeight = async (Guid, heightNumber) => {
  // 更新时间戳
  updateTimestampDebounced();
  try {
    // 修改对应层高
    await dbs.rlFloor
      .where("Guid")
      .equals(Guid)
      .modify(async (record) => {
        record.Height = +heightNumber;
        // record.LevelB = +levelB;
        return "更新成功";
      });
    var rlFloor = await getrlFloor();
    return rlFloor;
  } catch (error) {
    return false;
  }
};

// 查
export const getrlFloor = async (Guid) => {
  try {
    const res = Guid
      ? await dbs.rlFloor.where("Guid").equals(Guid).first()
      : await dbs.rlFloor.orderBy("No_").toArray(); // 使用 orderBy 方法按 "No_" 字段排序
    return res;
  } catch (error) {
    return [];
  }
};

/**
 * 标准层数据接口
 */

// 增 - 批量
export const resetAllRlStdFlr = async (arr) => {
  // 更新时间戳
  updateTimestampDebounced();

  // try
  try {
    await dbs.rlStdFlr.clear();
    await dbs.rlStdFlr.bulkAdd(arr);
    await putStdFlrNo();
  } catch (error) {}
};
// 增 - 单个
export const addrlStdFlr = async (obj) => {
  // 更新时间戳
  updateTimestampDebounced();
  try {
    await dbs.table("rlStdFlr").add(obj);
    return true;
  } catch (error) {
    return false;
  }
};
// 查
export const getrlStdFlr = async (stdFlrGuid) => {
  try {
    const res = await dbs.rlStdFlr.where("Guid").equals(stdFlrGuid).first();
    return res;
  } catch (error) {
    return false;
  }
};

// 删 - 单个
export const delrlStdFlr = async (Guid) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    await dbs.rlStdFlr.where("Guid").equals(Guid).delete();
    await delBulkRlFloor(Guid);
    // await putStdFlrNo();
    return "删除成功";
  } catch (error) {
    return false;
  }
};

// 查- 获取基础信息
export const getrlStdFlrAll = async (isInfo) => {
  try {
    // 使用局部变量，避免持久引用
    const res = await dbs.rlStdFlr.orderBy("No_").toArray();
    if (isInfo) {
      const info = res.map((item) => ({
        Guid: item.Guid,
        No_: item.No_,
        Height: item.Height,
      }));
      // 处理完后释放引用
      res.length = 0;
      return info;
    }
    return res;
  } catch (error) {
    return [];
  }
};

// 改 - 批量
export const updatelStdFlr = async (stdFlrGuid, obj) => {
  // 更新时间戳
  updateTimestampDebounced();
  try {
    await dbs.rlStdFlr.update(stdFlrGuid, obj);
    await putStdFlrNo();
    return "更新成功";
  } catch (error) {
    return false;
  }
};

// 按照类别批量新增
export const addBulkRlStdFlrFieldDatas = async (stdFlrGuid, field, arr) => {
  // 更新时间戳
  updateTimestampDebounced();
  try {
    await dbs.rlStdFlr
      .where("Guid")
      .equals(stdFlrGuid)
      .modify((record) => {
        if (!record[field]) {
          record[field] = {};
        }
        arr.forEach((item) => {
          record[field][item.Guid] = item;
        });
      });
    return "新增成功";
  } catch (error) {
    return false;
  }
};

// 按照类别批量删除
export const delBulkRlStdFlrFieldDatas = async (stdFlrGuid, delObjs) => {
  try {
    // 更新时间戳
    updateTimestampDebounced();
    await dbs.rlStdFlr
      .where("Guid")
      .equals(stdFlrGuid)
      .modify((record) => {
        Object.keys(delObjs).forEach((key) => {
          const objArray = delObjs[key];

          for (const item of objArray) {
            delete record[key][item.Guid];
          }
        });
      });
    return "删除成功";
  } catch (error) {
    console.log("error", error);

    return false;
  }
};

// 按照类别批量更新
export const updateBulkRlStdFlrFieldDatas = async (stdFlrGuid, updateObjs) => {
  try {
    if (!updateObjs || !Object.keys(updateObjs).length) return false;
    // 更新时间戳
    updateTimestampDebounced();
    // 实现在当前标准层中，按照类别批量更新数据，更新数据按照Guid查找替换
    await dbs.rlStdFlr
      .where("Guid")
      .equals(stdFlrGuid)
      .modify((record) => {
        Object.keys(updateObjs).forEach((key) => {
          const dataObjs = updateObjs[key];
          if (!record[key]) {
            record[key] = {};
          }

          if (dataObjs && dataObjs.length) {
            dataObjs.forEach((item) => {
              record[key][item.Guid] = item;
            });
          }
        });
      });
    return "更新成功";
  } catch (error) {
    console.log("error", error);
    return false;
  }
};

// 改 - 单个层高
export const updateOnlyStdFlr = async (stdFlrGuid, heightNumber) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    await dbs.rlStdFlr
      .where("Guid")
      .equals(stdFlrGuid)
      .modify(async (record) => {
        record.Height = +heightNumber;
        return "更新成功";
      });
  } catch (error) {
    return false;
  }
};

// 批量更新数据，使用下标+1自动补全字段
export const putStdFlrNo = async () => {
  dbs
    .transaction("rw", dbs.rlStdFlr, async () => {
      // 获取所有条目
      const allItems = await dbs.rlStdFlr.toArray();
      // 更新每个条目的 index 字段
      await Promise.all(
        allItems.map(async (item, index) => {
          // 在这里进行你的修改操作
          item.No_ = item.No_ ? item.No_ : index + 1;
          // 更新到数据库
          await dbs.rlStdFlr.put(item);
        })
      );
    })
    .then(() => {})
    .catch((error) => {});
};

// ------- 标准层-单个-增/改-节点:rlJoint/网格:rlGrid/轴线:rlAxis/墙布置:rlWallSeg/梁布置:rlBeamSeg/板布置:rlSlab/柱布置:rlColSeg/板洞布置:rlSlabHole/墙洞布置:rlWallHole/次梁布置:rlpkpmSubBeam/圈梁布置:rlRingBeamSeg/隔墙布置:rlPartitionWallSeg/悬挑板布置:rlCantiSlab
export const resetRlModules = async (field, stdFlrGuid, objectId, object) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    await dbs.rlStdFlr
      .where("Guid")
      .equals(stdFlrGuid)
      .modify(async (record) => {
        if (!record[field]) {
          if (isArray(objectId)) {
            record[field] = {};
            await objectId.map((item) => {
              record[field][item.id] = item.content;
            });
          } else {
            record[field] = { [objectId]: object };
          }
        } else {
          if (isArray(objectId)) {
            await objectId.map((item) => {
              record[field][item.id] = item.content;
            });
          } else {
            record[field][objectId] = object;
          }
        }
      });
    return "更新成功";
  } catch (error) {
    return false;
  }
};

export const resetRlModulesBatch = async (field, stdFlrGuid, objects) => {
  try {
    await dbs.rlStdFlr
      .where("Guid")
      .equals(stdFlrGuid)
      .modify((record) => {
        if (record[field]) {
          delete record[field];
        }
        objects.forEach(({ objectId, object }) => {
          if (!record[field]) {
            record[field] = { [objectId]: object };
          } else {
            record[field][objectId] = object;
          }
        });
      });
    return "批量更新成功";
  } catch (error) {
    return false;
  }
};

// export const resetRlModulesBatch = async (field, stdFlrGuid, objects) => {
//   try {
//     await dbs.rlStdFlr
//       .where("Guid")
//       .equals(stdFlrGuid)
//       .modify((record) => {
//         objects.forEach(({ objectId, object }) => {
//           if (!record[field]) {
//             record[field] = { [objectId]: object };
//           } else {
//             record[field][objectId] = object;
//           }
//         });
//       });
//     return "批量更新成功";
//   } catch (error) {
//     return false;
//   }
// };

export const addRlModules = async (field, stdFlrGuid, objectDatas) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    if (!objectDatas || !objectDatas.length) return false;

    await dbs.rlStdFlr
      .where("Guid")
      .equals(stdFlrGuid)
      .modify((record) => {
        objectDatas.forEach((obj) => {
          if (!record[field]) {
            record[field] = { [obj.Guid]: obj.object };
          } else {
            record[field][obj.Guid] = obj.object;
          }
        });
      });
    return "更新成功";
  } catch (error) {
    return false;
  }
};

// RlModules/模块-批量赋值
export const addAllRlModules = async (field, stdFlrGuid, Object) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    await dbs.rlStdFlr
      .where("Guid")
      .equals(stdFlrGuid)
      .modify((record) => {
        record[field] = Object;
      });
    return "赋值成功";
  } catch (error) {
    return false;
  }
};

//新增多个模块的数据--用于楼层局部复制
export const addRlModulesBatch = async (stdFlrGuid, objectDatas) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    await dbs.rlStdFlr
      .where("Guid")
      .equals(stdFlrGuid)
      .modify((record) => {
        Object.keys(objectDatas).forEach((key) => {
          if (!record[key]) {
            record[key] = {};
          }

          Object.keys(objectDatas[key]).forEach((obj) => {
            record[key][obj] = objectDatas[key][obj];
          });
        });
      });
    return "更新成功";
  } catch (error) {
    console.log("error", error);
    return false;
  }
};

// RlModules/模块-单个-删
export const delRlModules = async (field, stdFlrGuid, objectId) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    await dbs.rlStdFlr
      .where("Guid")
      .equals(stdFlrGuid)
      .modify((record) => {
        if (record[field]) {
          delete record[field][objectId];
        }
      });
    return "删除成功";
  } catch (error) {
    return false;
  }
};
// RlModules/节点-查
export const getRlModules = async (field, stdFlrGuid, objectId) => {
  try {
    const record = await getrlStdFlr(stdFlrGuid);
    return objectId !== undefined ? record[field][objectId] : record[field];
  } catch (error) {
    return false;
  }
};

// 将操作步骤下的所有数据更新到数据库中
export const dealRlModulesData = async (stdFlrGuid, databaseStore) => {
  try {
    // 更新时间戳
    updateTimestampDebounced();
    await dbs.rlStdFlr
      .where("Guid")
      .equals(stdFlrGuid)
      .modify((record) => {
        // 数据新增
        if (databaseStore["add"]) {
          for (const item of databaseStore["add"]) {
            if (!record[item.classTypeName]) {
              record[item.classTypeName] = {};
            }
            record[item.classTypeName][item.Guid] = item.getDataBase();
          }
        }

        // 数据编辑
        if (databaseStore["edit_after"] && databaseStore["edit_before"]) {
          for (const item of databaseStore["edit_after"]) {
            if (!record[item.classTypeName]) {
              record[item.classTypeName] = {};
            }

            record[item.classTypeName][item.Guid] = item.getDataBase();
          }
        }

        // 数据删除
        if (databaseStore["delete"]) {
          for (const item of databaseStore["delete"]) {
            delete record[item.classTypeName][item.Guid];
          }
        }
      });
    return "更新成功";
  } catch (error) {
    console.log("error", error);

    return false;
  }
};
// ------- 标准层-强度
// 批量赋值/改
export const resetAllRlStdFlrPara = async (stdFlrGuid, arr) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    await dbs.rlStdFlr
      .where("Guid")
      .equals(stdFlrGuid)
      .modify((record) => {
        record.rlStdFlrPara = arr;
      });
    return "层数据赋值成功";
  } catch (error) {
    return false;
  }
};
// 查
export const getRlStdFlrPara = async (stdFlrGuid) => {
  try {
    const record = await getrlStdFlr(stdFlrGuid);
    return record.rlStdFlrPara;
  } catch (error) {
    return false;
  }
};
/** *
 * 墙截面
 */
// 墙截面---查-找墙截面数据
export const getRlWallSect = async (isPage) => {
  try {
    const idbData = await dbs.rlWallSect.toArray();
    if (!isPage) {
      return idbData;
    }

    const resetData = idbData.map((item) => ({
      Guid: item.Guid,
      No_: item.No_,
      material: item.Mat,
      section_param: item.Kind,
      B: item.B,
      H: item.H,
      section: `${item.B}`,
      material_name: materialType.find((i) => i.value == item.Mat)?.label,
    }));

    // 处理完后释放引用
    idbData.length = 0;

    return resetData;
  } catch (error) {
    return false;
  }
};

// 墙截面---重置/赋值数据
export const resetAllRlWallSect = async (arr, isPage) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    // isPage?页面数据:接口数据
    // 清空表
    await dbs.rlWallSect.clear();

    var idbArr = [];
    if (isPage) {
      // 构造新数据-将页面数据转换为接口数据
      await Promise.all(
        arr.map(async (item, idx) => {
          var objs = {
            Guid: item.Guid, // 唯一值
            Name: "",
            No_: item.No_, // 顺序?
            Mat: item.material || 6, // 材料 对应material
            Kind: item.section_param || 1, // 截面参数  对应section_param 正多边形
            B: item.B,
            H: item.H || 0,
          };
          idbArr.push(objs);
        })
      );
    } else {
      idbArr = arr;
    }
    // 批量向表中覆盖数据
    await dbs.rlWallSect.bulkAdd(idbArr);
    return idbArr;
  } catch (error) {
    return false;
  }
};
// 墙截面---增/改-单条墙截面
export const addRlWallSect = async (addObj) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    // await dbs.rlWallSect.put(addObj);
    const NoLenght = await dbs.rlWallSect.toArray();
    var maxNo = 0;
    if (NoLenght.length > 0) {
      maxNo = Math.max(...NoLenght.map((item) => item.No_));
    }
    // 构造新数据
    var data = {
      Guid: addObj.Guid, // 唯一值
      Name: "",
      No_: NoLenght.length > 0 ? maxNo + 1 : 1, // 顺序?
      Mat: addObj.material || 6, // 材料 对应material
      Kind: addObj.section_param || 1, // 截面参数  对应section_param 正多边形
      B: addObj.B,
      H: addObj.H || 0,
    };
    // 批量向表中覆盖数据
    await dbs.rlWallSect.put(data);
    return data;
  } catch (error) {
    return false;
  }
};
// 墙截面---删-单条墙截面
export const delRlWallSect = async (Guid) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    await dbs.rlWallSect.where("Guid").equals(Guid).delete();
    return "删除成功";
  } catch (error) {
    return false;
  }
};
// 柱截面--- 查-批量获取柱截面数据
export const getRlColSect = async (isPage) => {
  try {
    const idbData = await dbs.rlColSect.toArray();
    if (!isPage) {
      return idbData;
    }

    const resetData = [];
    const sectionData = await getConstruct(301);

    for (const item of idbData) {
      const objs = await getKindType(item.Kind, sectionData);
      const idbToPage = await convertShapeValToParams(
        item.ShapeVal,
        objs.fieldKey
      );
      const cross = {
        ...idbToPage,
        Guid: item.Guid,
        No_: item.No_,
        type: 301,
        section_param: item.Kind,
        material: item.Mat,
        construction_column: item.Structural,
        label: objs.label,
        material_name: materialType.find((i) => i.value == item.Mat)?.label,
        formFields: objs.fieldKey,
      };
      if (objs.label === "型钢" && item.Name) {
        const values = item.Name.split("@");
        cross.customize = values[0];
        cross.sectionSteelType_name = values[1];
        cross.specifications = values[2];
        cross.R = values[3];
        const currentValue =
          steelSectionType.find(
            (e) => e.label === cross.sectionSteelType_name
          ) || {};

        if (currentValue.optionList && currentValue.optionList.length > 0) {
          const label =
            currentValue.optionList.find(
              (e) => e.value === cross.specifications
            )?.label || "";
          cross.specifications_name =
            values[0] === "true" ? cross.specifications : label;
        }
      }
      resetData.push(cross);
    }

    // 处理完后释放引用
    idbData.length = 0;
    sectionData.length = 0;

    return resetData;
  } catch (error) {
    console.log("error", error);
    return false;
  }
};

// /柱截面--- 重置-批量重置柱截面数据
export const resetAllRlColSect = async (arr, isPage) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    // 清空表
    await dbs.rlColSect.clear();
    // 构造新数据
    var idbArr = [];
    if (isPage) {
      await Promise.all(
        arr.map(async (item, idx) => {
          var shapKey = item.section.split("*").join(",");
          var objs = {
            Guid: item.Guid, // 唯一值
            No_: item.No_, // 顺序?
            Mat: item.material, // 材料 对应material
            Kind: item.section_param, // 截面参数  对应section_param 正多边形
            ShapeVal: `${item.section_param},${shapKey},${item.material},${item.Guid}`, // 对应Kind,Mat,formFields循环值,Guid
            Structural: item.construction_column, // 构造柱construction_column
            Name: "",
          };
          idbArr.push(objs);
        })
      );
    } else {
      idbArr = arr;
    }

    // 批量向表中覆盖数据
    await dbs.rlColSect.bulkAdd(idbArr);
    return idbArr;
  } catch (error) {
    return false;
  }
};
// 柱截面--- 增/改-单个增加柱截面数据
export const putRlColSect = async (addObj) => {
  // 更新时间戳
  updateTimestampDebounced();
  try {
    // 构造新数据
    var shapKey = addObj.section.split("*").join(",");
    const NoLenght = await dbs.rlColSect.toArray();
    var maxNo = 0;
    if (NoLenght.length > 0) {
      maxNo = Math.max(...NoLenght.map((item) => item.No_));
    }
    var data = {
      Guid: addObj.Guid, // 唯一值
      No_: NoLenght.length > 0 ? maxNo + 1 : 1, // 顺序?
      Mat: addObj.material, // 材料 对应material
      Kind: addObj.section_param, // 截面参数  对应section_param 正多边形
      ShapeVal: `${addObj.section_param},${shapKey},${addObj.material},${addObj.Guid}`, // 对应Kind,Mat,formFields循环值,Guid
      Structural: addObj.construction_column, // 构造柱construction_column
      Name: addObj.Name || "",
      // SectionSteelType_Name: addObj.sectionSteelType_name || "",
      OtherData: addObj.R,
    };
    // 批量向表中覆盖数据
    await dbs.rlColSect.put(data);
    return data;
  } catch (error) {
    return false;
  }
};

// 柱截面--- 删-删除单个柱截面数据
export const delRlColSect = async (Guid) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    await dbs.rlColSect.where("Guid").equals(Guid).delete();
    await delSectOrSeg(Guid, "rlColSeg");
    return "删除成功";
  } catch (error) {
    return false;
  }
};

// 梁截面 ---查-- 批量获取梁截面数据
export const getRlBeamSect = async (isPage) => {
  try {
    const idbData = await dbs.rlBeamSect.toArray();
    if (!isPage) {
      return idbData;
    }

    const resetData = [];
    const sectionData = await getConstruct(302);

    for (const item of idbData) {
      const objs = await getKindType(item.Kind, sectionData);
      const idbToPage = await convertShapeValToParams(
        item.ShapeVal,
        objs.fieldKey
      );
      const cross = {
        ...idbToPage,
        Guid: item.Guid,
        No_: item.No_,
        type: 302,
        section_param: item.Kind,
        material: item.Mat,
        label: objs.label,
        material_name: materialType.find((i) => i.value == item.Mat)?.label,
        formFields: objs.fieldKey,
        IsRingBeamSeg: item.IsRingBeamSeg,
      };
      if (objs.label === "型钢" && item.Name) {
        const values = item.Name.split("@");
        cross.customize = values[0];
        cross.sectionSteelType_name = values[1];
        cross.specifications = values[2];
        cross.R = values[3];
        const currentValue =
          steelSectionType.find(
            (e) => e.label === cross.sectionSteelType_name
          ) || {};

        if (currentValue.optionList && currentValue.optionList.length > 0) {
          const label =
            currentValue.optionList.find(
              (e) => e.value === cross.specifications
            )?.label || "";
          cross.specifications_name =
            values[0] === "true" ? cross.specifications : label;
        }
      }
      resetData.push(cross);
    }

    // 处理完后释放引用
    idbData.length = 0;
    sectionData.length = 0;

    return resetData;
  } catch (error) {
    return [];
  }
};
//  梁截面 ---重置-批量重置梁截面数据
export const resetAllRlBeamSect = async (arr, isPage) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    await dbs.rlBeamSect.clear();
    var idbArr = [];
    if (isPage) {
      await Promise.all(
        arr.map(async (item, idx) => {
          var shapKey = item.section.split("*").join(",");
          var objs = {
            Guid: item.Guid, // 唯一值
            Name: "",
            No_: item.No_, // 顺序?
            Mat: item.material, // 材料 对应material
            Kind: item.section_param, // 截面参数  对应section_param 正多边形
            ShapeVal: `${item.section_param},${shapKey},${item.material},${item.Guid}`, // 对应Kind,Mat,formFields循环值,Guid
          };
          idbArr.push(objs);
        })
      );
    } else {
      idbArr = arr;
    }
    // 批量向表中覆盖数据
    await dbs.rlBeamSect.bulkAdd(idbArr);
    return idbArr;
  } catch (error) {
    return false;
  }
};

// 梁截面--- 增/改-单个增加梁截面数据
export const putRlBeamSect = async (addObj) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    // 构造新数据
    var shapKey = addObj.section.split("*").join(",");
    const NoLenght = await dbs.rlBeamSect.toArray();
    var maxNo = 0;
    if (NoLenght.length > 0) {
      maxNo = Math.max(...NoLenght.map((item) => item.No_));
    }
    // 长度

    var data = {
      Guid: addObj.Guid, // 唯一值
      No_: NoLenght.length > 0 ? maxNo + 1 : 1, // 顺序?
      Mat: addObj.material, // 材料 对应material
      Kind: addObj.section_param, // 截面参数  对应section_param 正多边形
      ShapeVal: `${addObj.section_param},${shapKey},${addObj.material},${addObj.Guid}`, // 对应Kind,Mat,formFields循环值,Guid
      Name: addObj.Name || "",
      IsRingBeamSeg: addObj.IsRingBeamSeg,
    };
    // 批量向表中覆盖数据
    await dbs.rlBeamSect.put(data);
    return data;
  } catch (error) {
    return false;
  }
};

//  梁截面-- 删-删除单个梁截面数据
export const delRlBeamSect = async (Guid) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    await dbs.rlBeamSect.where("Guid").equals(Guid).delete();
    await delSectOrSeg(Guid, "rlBeamSeg");
    return "删除成功";
  } catch (error) {
    return false;
  }
};

// 板截面 --查---  批量获取板截面数据
export const getRlSlabSect = async (isPage) => {
  try {
    const idbData = await dbs.rlSlabSect.toArray();
    if (!isPage) {
      return idbData;
    }

    const resetData = idbData.map((item) => ({
      Guid: item.Guid,
      No_: item.No_,
      material: item.Mat,
      section_param: item.Kind,
      T: item.Thickness,
    }));

    // 处理完后释放引用
    idbData.length = 0;

    return resetData;
  } catch (error) {
    return false;
  }
};

//  板截面 ---重置-批量重置板截面数据
export const resetAllRlSlabSect = async (arr, isPage) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    // 清空表
    await dbs.rlSlabSect.clear();
    var idbArr = [];
    if (isPage) {
      await Promise.all(
        arr.map(async (item, idx) => {
          var objs = {
            Guid: item.Guid, // 唯一值
            Name: "",
            No_: item.No_, // 顺序?
            Mat: item.material, // 材料 对应material
            Kind: item.section_param, // 截面参数  对应section_param 正多边形
            Thickness: item.T,
          };
          idbArr.push(objs);
        })
      );
    } else {
      idbArr = arr;
    }

    // 批量向表中覆盖数据
    await dbs.rlSlabSect.bulkAdd(idbArr);
    return idbArr;
  } catch (error) {
    return false;
  }
};

// 板截面--- 增/改-单个增加板截面数据
export const putRlSlabSect = async (addObj) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    // 构造新数据
    const NoLenght = await dbs.rlSlabSect.toArray();
    var maxNo = 0;
    if (NoLenght.length > 0) {
      maxNo = Math.max(...NoLenght.map((item) => item.No_));
    }
    var data = {
      Guid: addObj.Guid, // 唯一值
      No_: NoLenght.length > 0 ? maxNo + 1 : 1, // 顺序?
      Mat: addObj.material || 6, // 材料 对应material
      Kind: addObj.section_param || 1, // 截面参数  对应section_param 正多边形
      Thickness: addObj.T,
      Name: "",
    };
    // 批量向表中覆盖数据
    await dbs.rlSlabSect.put(data);
    return data;
  } catch (error) {
    return false;
  }
};

//  板截面-- 删-删除单个板截面数据
export const delRlSlabSect = async (Guid) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    await dbs.rlSlabSect.where("Guid").equals(Guid).delete();
    await delSectOrSeg(Guid, "rlSlab");
    return "删除成功";
  } catch (error) {
    return false;
  }
};

// 圈梁截面-- 查-批量获取圈梁截面数据
export const getRlRingBeamSect = async (isPage) => {
  try {
    const idbData = await dbs.rlRingBeamSect.toArray();
    if (!isPage) {
      return idbData;
    }

    const resetData = [];
    const sectionData = await getConstruct(307);

    for (const item of idbData) {
      const objs = await getKindType(item.Kind, sectionData);
      const idbToPage = await convertShapeValToParams(
        item.ShapeVal,
        objs.fieldKey
      );
      const cross = {
        ...idbToPage,
        Guid: item.Guid,
        No_: item.No_,
        type: 307,
        section_param: item.Kind,
        material: item.Mat,
        label: objs.label,
        material_name: materialType.find((i) => i.value == item.Mat)?.label,
        formFields: objs.fieldKey,
      };
      resetData.push(cross);
    }

    // 处理完后释放引用
    idbData.length = 0;
    sectionData.length = 0;

    return resetData;
  } catch (error) {
    return false;
  }
};

// /圈梁截面--- 重置-批量重置圈梁截面数据
export const resetAllRlRingBeamSect = async (arr, isPage) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    // 清空表
    await dbs.rlRingBeamSect.clear();
    // 构造新数据
    var idbArr = [];
    if (isPage) {
      await Promise.all(
        arr.map(async (item, idx) => {
          var shapKey = item.section.split("*").join(",");
          var objs = {
            Guid: item.Guid, // 唯一值
            No_: item.No_, // 顺序?
            Mat: item.material, // 材料 对应material
            Kind: item.section_param, // 截面参数  对应section_param 正多边形
            ShapeVal: `${item.section_param},${shapKey},${item.material},${item.Guid}`, // 对应Kind,Mat,formFields循环值,Guid
            Name: "",
          };
          idbArr.push(objs);
        })
      );
    } else {
      idbArr = arr;
    }
    // 批量向表中覆盖数据
    await dbs.rlRingBeamSect.bulkAdd(idbArr);
    return idbArr;
  } catch (error) {
    return false;
  }
};

// 悬挑板截面---重置/赋值数据
export const resetAllRlCantiSlabDef = async (arr, isPage) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    // 清空表
    await dbs.rlCantiSlabDef.clear();
    var idbArr = [];
    if (isPage) {
      await Promise.all(
        arr.map(async (item, idx) => {
          var objs = {
            Guid: item.Guid, // 唯一值
            No_: item.No_, // 顺序
            Width: item.Length,
            Length: item.Width,
            Thick: item.Thick,
            Kind: item.Kind,
          };
          idbArr.push(objs);
        })
      );
    } else {
      idbArr = arr;
    }
    // 批量向表中覆盖数据
    await dbs.rlCantiSlabDef.bulkAdd(idbArr);
    return idbArr;
  } catch (error) {
    console.log("error", error);

    return false;
  }
};

/** *
 * 悬挑板截面
 */
// 悬挑板截面--- 增/改-单个增加悬挑板截面数据
export const putRlCantiSlabDef = async (addObj) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    // 构造新数据
    const NoLenght = await dbs.rlCantiSlabDef.toArray();
    var maxNo = 0;
    if (NoLenght.length > 0) {
      maxNo = Math.max(...NoLenght.map((item) => item.No_));
    }
    var data = {
      Guid: addObj.Guid, // 唯一值
      No_: NoLenght.length > 0 ? maxNo + 1 : 1, // 顺序?
      Width: Number(addObj.params.Length),
      Length: Number(addObj.params.Width),
      Thick: Number(addObj.params.Thick),
      Kind: addObj.section_param, // 截面参数  对应section_param 正多边形
      // 对应Kind,Mat,formFields循环值,Guid
    };
    // 批量向表中覆盖数据
    await dbs.rlCantiSlabDef.put(data);
    return data;
  } catch (error) {
    return false;
  }
};

// 悬挑板截面--- 删-删除单个悬挑板截面数据
export const delRlCantiSlabDef = async (Guid) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    await dbs.rlCantiSlabDef.where("Guid").equals(Guid).delete();
    await delSectOrSeg(Guid, "rlCantiSlabDef");
    return "删除成功";
  } catch (error) {
    return false;
  }
};

/** *
 * 悬挑板截面
 */
// 悬挑板截面---查-找悬挑板截面数据 rlCantiSlabDef
export const getRlCantiSlabDef = async (isPage) => {
  try {
    const idbData = await dbs.rlCantiSlabDef.toArray();
    if (!isPage) {
      return idbData;
    }
    const resetData = idbData.map((item) => ({
      Guid: item.Guid,
      No_: item.No_,
      Width: item.Length,
      Length: item.Width,
      Thick: item.Thick,
      Kind: item.Kind,
      material: 4,
      section: `${item.Width}*${item.Length}*${item.Thick}`,
    }));
    idbData.length = 0;
    return resetData;
  } catch (error) {
    return false;
  }
};

// 圈梁截面--- 增/改-单个增加圈梁截面数据
export const putRlRingBeamSect = async (addObj) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    // 构造新数据
    var shapKey = addObj.section.split("*").join(",");
    const NoLenght = await dbs.rlRingBeamSect.toArray();
    var maxNo = 0;
    if (NoLenght.length > 0) {
      maxNo = Math.max(...NoLenght.map((item) => item.No_));
    }
    var data = {
      Guid: addObj.Guid, // 唯一值
      No_: NoLenght.length > 0 ? maxNo + 1 : 1, // 顺序?
      Mat: addObj.material, // 材料 对应material
      Kind: addObj.section_param, // 截面参数  对应section_param 正多边形
      ShapeVal: `${addObj.section_param},${shapKey},${addObj.material},${addObj.Guid}`, // 对应Kind,Mat,formFields循环值,Guid
      Name: "",
    };
    // 批量向表中覆盖数据
    await dbs.rlRingBeamSect.put(data);
    return data;
  } catch (error) {
    return false;
  }
};

// 圈梁截面--- 删-删除单个圈梁截面数据
export const delRlRingBeamSect = async (Guid) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    await dbs.rlRingBeamSect.where("Guid").equals(Guid).delete();
    await delSectOrSeg(Guid, "rlRingBeamSeg");
    return "删除成功";
  } catch (error) {
    return false;
  }
};

/** *
 * 墙洞截面 - 305
 */
// 墙洞截面---查-找墙洞截面数据
export const getRlWallHoleDef = async (isPage) => {
  try {
    const idbData = await dbs.rlWallHoleDef.toArray();
    if (!isPage) {
      return idbData;
    }

    const resetData = idbData.map((item) => ({
      Guid: item.Guid,
      type: 305,
      section_param: 1,
      params: {
        B: item.B,
        H: item.H,
      },
      No_: item.No_,
      label: "矩形",
      section: `${item.B}*${item.H}`,
      formFields: ["B", "H"],
    }));

    // 处理完后释放引用
    idbData.length = 0;

    return resetData;
  } catch (error) {
    return false;
  }
};

// 墙洞截面---重置/赋值数据
export const resetAllRlWallHoleDef = async (arr, isPage) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    // isPage?页面数据:接口数据
    // 清空表
    await dbs.rlWallHoleDef.clear();

    var idbArr = [];
    if (isPage) {
      // 构造新数据-将页面数据转换为接口数据
      await Promise.all(
        arr.map(async (item, idx) => {
          var objs = {
            Guid: item.Guid, // 唯一值
            No_: item.No_, // 顺序
            B: item.params.B,
            H: item.params.H,
          };
          idbArr.push(objs);
        })
      );
    } else {
      idbArr = arr;
    }
    // 批量向表中覆盖数据
    await dbs.rlWallHoleDef.bulkAdd(idbArr);
    return idbArr;
  } catch (error) {
    return false;
  }
};
// 墙洞截面---增/改-单条墙洞截面
export const putRlWallHoleDef = async (addObj) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    // await dbs.rlWallHoleDef.put(addObj);
    const NoLenght = await dbs.rlWallHoleDef.toArray();
    var maxNo = 0;
    if (NoLenght.length > 0) {
      maxNo = Math.max(...NoLenght.map((item) => item.No_));
    }
    // 构造新数据
    var data = {
      Guid: addObj.Guid, // 唯一值
      No_: NoLenght.length > 0 ? maxNo + 1 : 1, // 顺序?
      B: addObj.params.B,
      H: addObj.params.H,
    };
    // 批量向表中覆盖数据
    await dbs.rlWallHoleDef.put(data);
    return data;
  } catch (error) {
    return false;
  }
};
// 墙洞截面---删-单条墙洞截面
export const delRlWallHoleDef = async (Guid) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    await dbs.rlWallHoleDef.where("Guid").equals(Guid).delete();
    await delSectOrSeg(Guid, "rlWallHole");
    return "删除成功";
  } catch (error) {
    return false;
  }
};

// 板洞截面--- 查-批量获取板洞截面数据
export const getRlslabholedef = async (isPage) => {
  try {
    const idbData = await dbs.rlSlabHoleDef.toArray();
    if (!isPage) {
      return idbData;
    }

    const resetData = [];
    const sectionData = await getConstruct(306);

    for (const item of idbData) {
      const objs = await getKindType(item.Kind, sectionData);
      const idbToPage = await convertShapeValToParams(
        item.ShapeVal,
        objs.fieldKey
      );
      const cross = {
        ...idbToPage,
        Guid: item.Guid,
        No_: item.No_,
        type: 306,
        section_param: item.Kind,
        label: objs.label,
        material_name: materialType.find((i) => i.value == item.Mat)?.label,
        formFields: objs.fieldKey,
      };
      resetData.push(cross);
    }

    // 处理完后释放引用
    idbData.length = 0;
    sectionData.length = 0;

    return resetData;
  } catch (error) {
    return false;
  }
};
// /板洞截面--- 重置-批量重置板洞截面数据
export const resetAllRlslabholedef = async (arr, isPage) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    // 清空表
    await dbs.rlSlabHoleDef.clear();
    // 构造新数据
    var idbArr = [];
    if (isPage) {
      await Promise.all(
        arr.map(async (item, idx) => {
          var shapKey = item.section.split("*").join(",");
          var objs = {
            Guid: item.Guid, // 唯一值
            No_: item.No_, // 顺序?
            Kind: item.section_param, // 截面参数  对应section_param 正多边形
            ShapeVal: `${item.section_param},${shapKey},6,${item.Guid}`, // 对应
          };
          idbArr.push(objs);
        })
      );
    } else {
      idbArr = arr;
    }
    // 批量向表中覆盖数据
    await dbs.rlSlabHoleDef.bulkAdd(idbArr);
    return idbArr;
  } catch (error) {
    return false;
  }
};
// 板洞截面--- 增/改-单个增加板洞截面数据
export const putRlslabholedef = async (addObj) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    // 构造新数据
    var shapKey = addObj.section.split("*").join(",");

    const NoLenght = await dbs.rlSlabHoleDef.toArray();
    var maxNo = 0;
    if (NoLenght.length > 0) {
      maxNo = Math.max(...NoLenght.map((item) => item.No_));
    }
    var data = {
      Guid: addObj.Guid, // 唯一值
      No_: NoLenght.length > 0 ? maxNo + 1 : 1, // 顺序?
      Kind: addObj.section_param, // 截面参数  对应section_param 正多边形
      ShapeVal: `${addObj.section_param},${shapKey},6,${addObj.Guid}`, // 对应Kind,Mat,formFields循环值,Guid
    };
    // 批量向表中覆盖数据
    await dbs.rlSlabHoleDef.put(data);
    return data;
  } catch (error) {
    return false;
  }
};

// 板洞截面--- 删-删除单个板洞截面数据
export const delRlslabholedef = async (Guid) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    await dbs.rlSlabHoleDef.where("Guid").equals(Guid).delete();
    await delSectOrSeg(Guid, "rlSlabHole");
    return "删除成功";
  } catch (error) {
    return false;
  }
};

/** *
 * 隔墙截面
 */
// 隔墙截面---查-找隔墙截面数据 rlPartitionWallSect
export const getrlPartitionWallSect = async (isPage) => {
  try {
    const idbData = await dbs.rlPartitionWallSect.toArray();
    if (!isPage) {
      return idbData;
    }

    const resetData = idbData.map((item) => ({
      Guid: item.Guid,
      Name: item.Name || "",
      No_: item.No_,

      section_param: item.Kind,
      B: item.B,
      section: `${item.B}`,
    }));

    // 处理完后释放引用
    idbData.length = 0;

    return resetData;
  } catch (error) {
    return false;
  }
};
// 隔墙截面---重置/赋值数据
export const resetAllrlPartitionWallSect = async (arr, isPage) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    // isPage?页面数据:接口数据
    // 清空表
    await dbs.rlPartitionWallSect.clear();

    var idbArr = [];
    if (isPage) {
      // 构造新数据-将页面数据转换为接口数据
      await Promise.all(
        arr.map(async (item, idx) => {
          var objs = {
            Guid: item.Guid, // 唯一值
            Name: "",
            No_: item.No_, // 顺序?

            Kind: item.section_param || 1, // 截面参数  对应section_param
            B: item.B,
          };
          idbArr.push(objs);
        })
      );
    } else {
      idbArr = arr;
    }
    // 批量向表中覆盖数据
    await dbs.rlPartitionWallSect.bulkAdd(idbArr);
    return idbArr;
  } catch (error) {
    return false;
  }
};

// 隔墙截面---增/改-单条隔墙截面
export const putrlPartitionWallSect = async (addObj) => {
  // 更新时间戳
  updateTimestampDebounced();
  try {
    const NoLenght = await dbs.rlPartitionWallSect.toArray();
    var maxNo = 0;
    if (NoLenght.length > 0) {
      maxNo = Math.max(...NoLenght.map((item) => item.No_));
    }
    // 构造新数据
    var data = {
      Guid: addObj.Guid, // 唯一值
      Name: "",
      No_: NoLenght.length > 0 ? maxNo + 1 : 1, // 顺序?

      Kind: addObj.section_param || 1, // 截面参数  对应section_param 正多边形
      B: addObj.B,
    };
    // 批量向表中覆盖数据
    await dbs.rlPartitionWallSect.put(data);
    return data;
  } catch (error) {
    return false;
  }
};
// 隔墙截面---删-单条墙截面
export const delrlPartitionWallSect = async (Guid) => {
  // 更新时间戳
  updateTimestampDebounced();
  try {
    await dbs.rlPartitionWallSect.where("Guid").equals(Guid).delete();
    return "删除成功";
  } catch (error) {
    return false;
  }
};

/** *
 * 门窗截面
 */
// 门窗截面---查-找门窗截面数据 rlDoorsWindowsDef
export const getrlDoorsWindowsDef = async (isPage) => {
  try {
    const idbData = await dbs.rlDoorsWindowsDef.toArray();

    if (!isPage) {
      return idbData;
    }
    const resetData = idbData.map((item) => ({
      Guid: item.Guid,
      No_: item.No_,
      B: item.B,
      H: item.H,
      section: `${item.B}*${item.H}`,
    }));
    idbData.length = 0;
    return resetData;
  } catch (error) {
    return false;
  }
};
// 门窗截面---重置/赋值数据
export const resetAllrlDoorsWindowsDef = async (arr, isPage) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    // isPage?页面数据:接口数据
    // 清空表
    await dbs.rlDoorsWindowsDef.clear();

    var idbArr = [];
    if (isPage) {
      // 构造新数据-将页面数据转换为接口数据
      await Promise.all(
        arr.map(async (item, idx) => {
          var objs = {
            Guid: item.Guid, // 唯一值
            No_: item.No_, // 顺序?
            B: item.B,
            H: item.H || 0,
          };
          idbArr.push(objs);
        })
      );
    } else {
      idbArr = arr;
    }
    // 批量向表中覆盖数据
    await dbs.rlDoorsWindowsDef.bulkAdd(idbArr);
    return idbArr;
  } catch (error) {
    return false;
  }
};

// 门窗截面---增/改-单条门窗截面
export const putrlDoorsWindowsDef = async (addObj) => {
  // 更新时间戳
  updateTimestampDebounced();
  try {
    const NoLenght = await dbs.rlDoorsWindowsDef.toArray();
    var maxNo = 0;
    if (NoLenght.length > 0) {
      maxNo = Math.max(...NoLenght.map((item) => item.No_));
    }
    // 构造新数据
    var data = {
      Guid: addObj.Guid, // 唯一值
      No_: NoLenght.length > 0 ? maxNo + 1 : 1, // 顺序?
      B: addObj.params.B,
      H: addObj.params.H || 0,
    };
    // 批量向表中覆盖数据
    await dbs.rlDoorsWindowsDef.put(data);
    return data;
  } catch (error) {
    return false;
  }
};
// 门窗截面---删-单条门窗截面
export const delrlDoorsWindowsDef = async (Guid) => {
  // 更新时间戳
  updateTimestampDebounced();
  try {
    await dbs.rlDoorsWindowsDef.where("Guid").equals(Guid).delete();
    return "删除成功";
  } catch (error) {
    return false;
  }
};

// 图层-改/增-单个
export const putRlLayer = async ({ type, color, desc }) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    await dbs.rlLayer.put({ type, color, desc });
    return true;
  } catch (error) {
    return false;
  }
};

// 图层-改-批量
export const resetAllRlLayer = async (arr) => {
  // 更新时间戳
  updateTimestampDebounced();

  try {
    dbs.rlLayer.clear();
    // 批量向表中覆盖数据
    await dbs.rlLayer.bulkAdd(arr);
    return arr;
  } catch (error) {
    return false;
  }
};

// 图层-查
export const getRlLayer = async () => {
  try {
    const res = await dbs.rlLayer.orderBy("No_").toArray(); // 使用 orderBy 方法按 "No_" 字段排序
    return res;
  } catch (error) {
    return false;
  }
};

/**
 *
 * 所有截面统一处理
 * 301:柱;302:梁;303:墙;304:板;308:飘板;
 */
// 获取数据-传入页面数据
export const getSectionFun = async (id, isPage) => {
  let res = [];
  switch (id) {
    // 301:柱
    case 301:
      res = await getRlColSect(isPage);
      break;
    // 302:梁
    case 302:
      res = await getRlBeamSect(isPage);
      break;
    // 303:墙
    case 303:
      res = await getRlWallSect(isPage);
      break;
    // 304:板
    case 304:
      res = await getRlSlabSect(isPage);
      break;
    // 305:墙洞
    case 305:
      res = await getRlWallHoleDef(isPage);
      break;
    // 306:板洞
    case 306:
      res = await getRlslabholedef(isPage);
      break;
    // 307:圈梁
    case 307:
      res = await getRlRingBeamSect(isPage);
      break;
    // 308:悬挑板
    case 308:
      res = await getRlCantiSlabDef(isPage);
      break;
    // 309:次梁
    case 309:
      res = await getRlBeamSect(isPage);
      break;
    // 310:隔墙
    case 310:
      res = await getrlPartitionWallSect(isPage);
      break;
    // 311:门窗
    case 311:
      res = await getrlDoorsWindowsDef(isPage);
      break;
    default:
      res = [];
      break;
  }
  return res;
};
// 增/改数据
export const editSectionFun = async (id, datas, isEdit) => {
  // console.log("editSectionFun", editSectionFun);
  // 时间戳
  updateTimestampDebounced();
  let res;
  let field = "";
  switch (id) {
    // 301:柱
    case 301:
      res = isEdit ? await putRlColSect(datas) : await delRlColSect(datas);
      field = "rlColSeg";
      break;
    // 302:梁
    case 302:
      res = isEdit ? await putRlBeamSect(datas) : await delRlBeamSect(datas);
      field = "rlBeamSeg";
      break;
    // 303:墙
    case 303:
      res = isEdit ? await addRlWallSect(datas) : await delRlWallSect(datas);
      field = "rlWallSeg";
      break;
    // 304:板
    case 304:
      res = isEdit ? await putRlSlabSect(datas) : await delRlSlabSect(datas);
      field = "rlSlab";
      break;
    // 305:墙洞
    case 305:
      res = isEdit
        ? await putRlWallHoleDef(datas)
        : await delRlWallHoleDef(datas);
      field = "rlWallHoleSeg";
      break;
    // 306:板洞
    case 306:
      res = isEdit
        ? await putRlslabholedef(datas)
        : await delRlslabholedef(datas);
      field = "rlSlabHole";
      break;
    // 307:圈梁
    case 307:
      res = isEdit
        ? await putRlRingBeamSect(datas)
        : await delRlRingBeamSect(datas);
      field = "rlRingBeamSeg";
      break;
    // 308:悬挑板
    case 308:
      res = isEdit
        ? await putRlCantiSlabDef(datas)
        : await delRlCantiSlabDef(datas);
      field = "rlCantiSlabDef";
      break;
    // 309:次梁
    case 309:
      res = isEdit ? await putRlBeamSect(datas) : await delRlBeamSect(datas);
      field = "rlSubBeam";
      break;
    // 310:隔墙
    case 310:
      res = isEdit
        ? await putrlPartitionWallSect(datas)
        : await delrlPartitionWallSect(datas);
      field = "rlPartitionWallSeg";
      break;
    // 311:门窗
    case 311:
      res = isEdit
        ? await putrlDoorsWindowsDef(datas)
        : await delrlDoorsWindowsDef(datas);
      field = "rlDoorsWindows";
      break;
    default:
      res = false;
      break;
  }

  if (res && !isEdit) {
    // 删除对应构件数据
    await deleteModelBySection(datas, field);
  }

  return res;
};

// 删除构件数据
const deleteModelBySection = async (sectGuid, field) => {
  try {
    // 循环标准层，依次删除标准层中对应截面的构件数据
    const allItems = await dbs.rlStdFlr.toArray();
    await Promise.all(
      allItems.map(async (item) => {
        if (item[field]) {
          for (const key in item[field]) {
            if (item[field][key]["SectGuid"] == sectGuid) {
              delete item[field][key];
            }
          }
        }
      })
    );
    await dbs.rlStdFlr.bulkPut(allItems);
    return true;
  } catch (error) {
    return false;
  }
};
export const delSectOrSeg = async (Guid, field) => {
  // 时间戳
  updateTimestampDebounced();
  // 批量更新数据，使用下标+1自动补全字段
  await dbs.transaction("rw", dbs.rlStdFlr, async () => {
    // 获取所有条目
    const allItems = await dbs.rlStdFlr.toArray();
    // 更新每个条目的 index 字段
    await Promise.all(
      allItems.map(async (item, index) => {
        for (const key in item[field]) {
          if (item[field][key]["SectGuid"] == Guid) {
            // 删除满足条件的键值对
            delete item[field][key];
          }
        }
      })
    );
    await dbs.rlStdFlr.bulkPut(allItems);
  });
};

// 获取指定数据库的所有数据
export async function getAllDataWithDexie(dbName) {
  if (!dbName) {
    console.error("请提供数据库名称作为参数");
    return null;
  }

  try {
    const tableNames = dbs.tables.map((table) => table.name);
    console.log(`数据库包含的表:`, tableNames);
    // 存储所有表的数据
    const allData = {};
    // 遍历所有表并获取数据
    for (const tableName of tableNames) {
      try {
        const tableData = await dbs.table(tableName).toArray();
        allData[tableName] = tableData;
        console.log(
          `已获取表 "${tableName}" 的数据，共 ${tableData.length} 条记录`
        );
      } catch (error) {
        console.error(`获取表 "${tableName}" 数据失败:`, error);
        allData[tableName] = { error: error.message };
      }
    }
    console.log(`\n数据库 "${dbName}" 的所有数据获取完成:`);
    console.log(allData);
    return allData;
  } catch (error) {
    console.error(`操作数据库 "${dbName}" 时发生错误:`, error);
    return null;
  }
}

// 辅助函数：获取数据并提供下载选项
export async function fetchAndDownloadWithDexie(dbName, fileName) {
  const allData = await getAllDataWithDexie(dbName);
  if (allData && Object.keys(allData).length > 0) {
    const download = confirm(`是否要下载模型的数据?`);
    if (download) {
      const dataStr = JSON.stringify(allData, null, 2);
      const blob = new Blob([dataStr], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${fileName}-dexie-data.json`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
  }
}

//判断该截面数据是否已经再模型存在
export async function getSectIsExist(sect, type) {
  const allItems = await dbs.rlStdFlr.toArray();
  return allItems?.some((item) => {
    const keys = item && item[type] ? Object.keys(item[type]) : [];
    return keys?.some((key) => {
      return item[type][key].SectGuid === sect.Guid;
    });
  });
}
